import React from 'react';
import classNames from 'classnames';
import {
  IconButton,
  ListItem,
  makeStyles,
  Typography
} from '@material-ui/core';

import { DOC, DOCX, JPEG, PDF, PNG } from '../../../constants/file-upload';

import { CustomIcon } from '../index';
import { onClickWrapper } from '../../../utils/ui';

const TYPES_ICONS = {
  [PDF]: 'pdfIcon',
  [DOC]: 'wordIcon',
  [DOCX]: 'wordIcon',
  [JPEG]: 'imageIcon',
  [PNG]: 'imageIcon'
};

const useStyles = makeStyles(theme => ({
  name: {
    marginLeft: 8,
    color: theme.palette.text.secondary,
    wordBreak: 'break-all'
  },
  remove: {
    marginLeft: 'auto',
    padding: 4
  }
}));

const FilePreview = ({ className, file, onRemove, removeButtonId }) => {
  const classes = useStyles();

  return (
    <ListItem className={className}>
      <CustomIcon
        size="small"
        icon={TYPES_ICONS[file.type]}
        variant="primary"
      />
      <Typography
        className={classNames(classes.name)}
        variant="body2"
        component="span"
      >
        {file.name}
      </Typography>
      <IconButton
        className={classes.remove}
        aria-label="remove"
        id={removeButtonId}
        onClick={onClickWrapper(removeButtonId, onRemove)}
      >
        <CustomIcon size="small" icon="dismissIcon" variant="hint" />
      </IconButton>
    </ListItem>
  );
};

export default FilePreview;
